import { bookingType } from 'Models/Enums';
import { BookingPricingResult } from 'Services/Api/_HumanWritten/PricingService/PricingResult';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';

export const getBookingTypesFromTransactionPricingHelper = (transactionPricingResults?: BookingPricingResult[]) => {
	const bookingTypes = new Set<bookingType>();

	if (!transactionPricingResults) {
		return [];
	}

	for (const transactionPricingResult of transactionPricingResults) {
		if (transactionPricingResult.bookingType) {
			bookingTypes.add(transactionPricingResult.bookingType);
		}
	}
	return Array.from(bookingTypes);
};

export const getTabSelectedByBookingType = (typeOfBooking: bookingType): TabSelected => {
	switch (typeOfBooking) {
		case 'FREIGHT':
			return 'freight';
		case 'VEHICLE':
		case 'VEHICLE_AND_PASSENGER':
			return 'vehicle';
		default:
			return 'passenger';
	}
};
